module.exports = __webpack_public_path__ + "img/zanwu.0071fd2b.png";